(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gl-brand-navigation"] && !Shopify.designMode) return;
  try {
    function setupGoldenLocksCategoryBrowsers(scope) {
  scope.querySelectorAll('.gl-category-browser').forEach((browser) => {
    if (browser.dataset.mobileReady) return;
    browser.dataset.mobileReady = 'true';
    const mobile = window.matchMedia('(max-width: 767px)');
    const sync = () => { browser.open = !mobile.matches; };
    sync();
    mobile.addEventListener('change', sync);
  });
}
setupGoldenLocksCategoryBrowsers(document);
document.addEventListener('shopify:section:load', (event) => setupGoldenLocksCategoryBrowsers(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gl-hoppe-hardware-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const summary = event.target.closest('.gl-hoppe-menu summary');
  if (!summary) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const panel = summary.parentElement;
  panel.open = !panel.open;
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gl-schlage-tabs"] && !Shopify.designMode) return;
  try {
    function setupGoldenLocksSchlageTabs(scope) {
  scope.querySelectorAll('[data-schlage-tabs]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    const groups = root.querySelector('[data-schlage-groups]');
    const details = Array.from(root.querySelectorAll('[data-schlage-detail]'));
    const breadcrumb = root.querySelector('[data-schlage-current]');
    let currentTrigger;
    const resetCommercial = (restoreFocus) => {
      groups.hidden = false;
      details.forEach((panel) => { panel.hidden = true; });
      breadcrumb.hidden = true;
      breadcrumb.textContent = '';
      if (restoreFocus && currentTrigger) currentTrigger.focus();
    };
    const selectTab = (tab, moveFocus) => {
      resetCommercial(false);
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      if (moveFocus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        selectTab(tabs[next], true);
      });
    });
    root.querySelectorAll('[data-schlage-group]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const panel = details.find((item) => item.dataset.schlageDetail === trigger.dataset.schlageGroup);
        if (!panel) return;
        currentTrigger = trigger;
        groups.hidden = true;
        details.forEach((item) => { item.hidden = item !== panel; });
        breadcrumb.textContent = '› ' + trigger.querySelector('h3').textContent.trim();
        breadcrumb.hidden = false;
        panel.querySelector('h2').focus({ preventScroll: true });
      });
    });
    root.querySelector('[data-schlage-root]').addEventListener('click', () => resetCommercial(true));
  });
}
setupGoldenLocksSchlageTabs(document);
document.addEventListener('shopify:section:load', (event) => setupGoldenLocksSchlageTabs(event.target));
  } catch(e) { console.error(e); }
})();

})();
